import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Coupon, fetchCoupons } from '../couponApi';

export interface CouponState {
  coupons: Coupon[];
  loading: boolean;
  error: string | null;
  couponTransId: string | null;
}

const initialState: CouponState = {
  coupons: [],
  loading: false,
  error: null,
  couponTransId: sessionStorage.getItem('redux_coupon_trans_id') || null,
};

const mapCoupon = (c: any) => ({
  id: c.id,
  code: c.coupon_code ?? c.code,
  title: c.coupon_name ?? c.title,
  description: c.coupon_description ?? c.description,
  discount: typeof (c.coupon_discount ?? c.discount) === 'string'
    ? parseInt(String(c.coupon_discount ?? c.discount).replace(/[^\d]/g, ''), 10)
    : (c.coupon_discount ?? c.discount ?? 0),
  expiry: c.coupon_end_date ?? c.expiry,
});

export const fetchCouponsThunk = createAsyncThunk('coupons/fetchCoupons', async (_, { rejectWithValue }) => {
  try {
    const coupons = await fetchCoupons();
    return Array.isArray(coupons) ? coupons.map(mapCoupon) : [];
  } catch (error: any) {
    return rejectWithValue(error?.response?.data?.message || 'Failed to fetch coupons');
  }
});

const couponSlice = createSlice({
  name: 'coupons',
  initialState,
  reducers: {
    setCouponTransId(state, action) {
      state.couponTransId = action.payload;
      if (action.payload) {
        sessionStorage.setItem('redux_coupon_trans_id', action.payload);
      } else {
        sessionStorage.removeItem('redux_coupon_trans_id');
      }
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCouponsThunk.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCouponsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.coupons = action.payload;
      })
      .addCase(fetchCouponsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch coupons';
      });
  },
});

export const { setCouponTransId } = couponSlice.actions;
export default couponSlice.reducer;
